// import React from 'react';
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import profileIcon from '../../assets/images/profile-icon.svg';
import { logoutUser, getSelfEvaluationStatus } from "../../api";
import useRuleProgress from '../../hooks/useRuleProgress';

// import BuilderRules from "../BuilderRules";
import ScoringNotify from '../ScoringNotify';

import { API_BASE_URL, WEB_SOCKET_BASE_URL } from '../../config';
// import BuilderRules from "../BuilderRules";
// import ScoringNotify from '../ScoringNotify';



function Header({ onSelfEvaluationUpdate }) {
    // const {isScoreVisible,renderContent} = BuilderRules();

    const [process, setprocess] = useState(null);
    const [isScoreVisible, setScoreVisible] = useState(false);
    const [selectedBuilder, setSelectedBuilder] = useState(null);
    const [avgScore, setAvgScore] = useState(null);
    const [filters, setFilters] = useState(null);
    const location = useLocation();
    const isActive = (path) => location.pathname === path;
    const email = localStorage.getItem('loggedInUserEmail')?.toLowerCase();
    const isAdmin = localStorage.getItem('is_admin') === 'true';
    const [isEvaluationPopupVisible, setEvaluationPopupVisible] = useState(false);
    const [notifications, setNotifications] = useState([]);
    const closeEvaluationPopup = (e) => {
        e.preventDefault();
        setEvaluationPopupVisible(false);
    };
    const [message, setMessage] = useState('');
    const [lastHeartbeat, setLastHeartbeat] = useState(Date.now());
    const [connectionStatus, setConnectionStatus] = useState('connected');
    // Rule sets compiling or scoring, from the server, so the count survives a page reload.
    const runningRuleSets = useRuleProgress();
    const heartbeatTimeoutRef = useRef(null);
    const lastSelfEvalFailRef = useRef({ msg: null, time: 0 });

    const resetHeartbeatTimeout = useCallback(() => {
        if (heartbeatTimeoutRef.current) {
            clearTimeout(heartbeatTimeoutRef.current);
        }
        heartbeatTimeoutRef.current = setTimeout(() => {
            setConnectionStatus('disconnected');
        }, 45000); // 45 second timeout
    }, []);

    const handleHeartbeat = useCallback(() => {
        setLastHeartbeat(Date.now());
        setConnectionStatus('connected');
        resetHeartbeatTimeout();
    }, [resetHeartbeatTimeout]);

    // Function to handle the data from child
    const handleMessageFromChild = (data) => {
        setMessage(data);
    };

    const handleWebSocketMessage = async (data,flag) => {
        const newNotification = { id: Date.now(), text: data };
        if (flag){
            setNotifications((prevNotifications) => {
                const updatedNotifications = [...prevNotifications, newNotification];
                // Limit to a maximum of 5 notifications
                if (updatedNotifications.length > 5) {
                    updatedNotifications.shift(); // Remove the oldest notification
                }
                return updatedNotifications;
            });
        }
        else{
            setNotifications((prevNotifications) => [...prevNotifications, newNotification]);
            // setNotifications(newNotification);
        }
    };
    const handleNotificationClose = (id) => {
        setNotifications((prev) => prev.filter((n) => n.id !== id));
        setTimeout(() => {
            // Hide wrapper when no notifications left
            if (notifications.length <= 1) {
                setScoreVisible(false);
            }
        }, 0);
    };
    const avg_score_data = useCallback(async () => {
        let filters = "All";
        if (localStorage.getItem("isEvaluating") === "True") { 
            setAvgScore("Evaluating");
        }
        else{
            try {
                const response = await fetch(
                    `${API_BASE_URL}/call_avg_score_data/?filters=${encodeURIComponent(filters)}`,
                    { method: 'GET' }
                );
                if (!response.ok) {
                    throw new Error('Self Evaluation API call failed.');
                }
                const data = await response.json();
                if (data){
                    setAvgScore(data);
                }
            } catch (error){
                console.error('Error during Self Evaluation:', error);

            }
    }
    },[]);

    // Clears an "Evaluating" badge left by a run that died without sending complete/failed:
    // checked on load and whenever heartbeats stop.
    const syncEvaluationStatus = useCallback(async () => {
        try {
            const status = await getSelfEvaluationStatus();
            if (!status.running && localStorage.getItem("isEvaluating") === "True") {
                localStorage.setItem("isEvaluating", "False");
                avg_score_data();
            }
        } catch (error) {
            console.error('Could not check the self evaluation status:', error);
        }
    }, [avg_score_data]);

    useEffect(() => {
        syncEvaluationStatus();
    }, [syncEvaluationStatus]);

    useEffect(() => {
        if (connectionStatus === 'disconnected') syncEvaluationStatus();
    }, [connectionStatus, syncEvaluationStatus]);

    useEffect(() => {
    
        // Initialize WebSocket connection
        const ws = new WebSocket(`${WEB_SOCKET_BASE_URL}/ws`);
    
    
        ws.onmessage = async (event) => {
            let message = event.data;
            if (!message) return false;
            
            message = JSON.parse(event.data);
            
            // Handle heartbeat - new format
            if (message.type === 'heartbeat') {
                handleHeartbeat();
                return;
            }
            
            // Support both old and new formats
            const messageText = message.message || message.type;
            
            // New typed events for self-evaluation
            if (message.type === 'self_evaluation_start') {
                localStorage.setItem("isEvaluating", "True");
                avg_score_data();
                return;
            }
            if (message.type === 'self_evaluation_complete') {
                setprocess('Self Evaluation');
                let builder_name = '';
                setSelectedBuilder({builder_name});
                setScoreVisible(true);
                localStorage.setItem("isEvaluating", "False");
                avg_score_data();
                await handleWebSocketMessage('Self Evaluation process completed',false);
                return;
            }
            if (message.type === 'self_evaluation_failed') {
                localStorage.setItem("isEvaluating", "False");
                setprocess('Self Evaluation Failed');
                let builder_name = '';
                setSelectedBuilder({builder_name});
                setScoreVisible(true);
                avg_score_data();
                const text = `❌ Self Evaluation FAILED: ${message.error}`;
                const now = Date.now();
                // If we already showed a failure toast recently, skip
                if (lastSelfEvalFailRef.current && lastSelfEvalFailRef.current.msg === text && (now - lastSelfEvalFailRef.current.time) < 5000) {
                    return;
                }
                // If there is an existing self-eval failure notification, do not add another
                if (notifications && notifications.some(n => (n.text || '').includes('Self Evaluation FAILED'))) {
                    return;
                }
                // Do not show numeric-only score messages like "98" on failure
                const isNumericError = /^\d+(?:\.\d+)?$/.test(String(message.error ?? ''));
                if (isNumericError) {
                    return;
                }
                lastSelfEvalFailRef.current = { msg: text, time: now };
                await handleWebSocketMessage(text, true);
                return;
            }
            
            if (messageText === 'Self Evaluation Process Start') {
                localStorage.setItem("isEvaluating", "True");
                avg_score_data();
            } else if (messageText === 'Self Evaluation Process Completed!' || messageText === 'Self Evaluation Process Complete') {
                setprocess('Self Evaluation');
                let builder_name = '';
                setSelectedBuilder({builder_name});
                setScoreVisible(true);
                let filters = message.filters;
                if (onSelfEvaluationUpdate) {
                    onSelfEvaluationUpdate(filters);
                }
                await handleWebSocketMessage('Self Evaluation process completed',false);
            } else if (messageText === 'Scoring process failed') {
                localStorage.setItem("isEvaluating", "False");
                window.location.reload();
            } else if (messageText === 'Scoring process completed!') {
                let builder_name = message.builder_name;
                setprocess('Scoring');
                setSelectedBuilder({builder_name});
                setScoreVisible(true);
                localStorage.setItem("isEvaluating", "False");
                avg_score_data();
                await handleWebSocketMessage('Scoring process completed for task ' + new Date().toLocaleTimeString(),true);
            } else if (message.type === 'rescoring_complete') {
                // Set process type and selected builder
                setprocess('Rescoring');
                setSelectedBuilder({builder_name: message.builder_name});
                
                // Show score notification
                setScoreVisible(true);
                
                // Refresh the average score
                avg_score_data();
                
                // Show notification in top-right corner
                await handleWebSocketMessage(`Rescoring completed for ${message.builder_name}`, true);
            } else if (message.type === 'rescoring_failed') {
                // Set process type to indicate FAILURE (not success)
                setprocess('Rescoring Failed');
                setSelectedBuilder({builder_name: message.builder_name});
                
                // Enable score visibility for notifications to show
                setScoreVisible(true);
                
                // Show failure notification with clear failure message
                await handleWebSocketMessage(`❌ Rescoring FAILED for ${message.builder_name}: ${message.error}`, true);
            }
        
        };
    
        ws.onerror = (error) => {
            console.error("WebSocket error:", error.message || error);
        };
    
        ws.onclose = () => {
            console.warn("WebSocket connection closed");
        };
    
        ws.onopen = () => {
            console.log("WebSocket connection established");
            setConnectionStatus('connected');
            resetHeartbeatTimeout();
        };
    
        return () => {
            // Cleanup WebSocket connection on component unmount
            if (heartbeatTimeoutRef.current) {
                clearTimeout(heartbeatTimeoutRef.current);
            }
            ws.close();
        };
    }, []);

    const handleLogout = async () => {
        try {
            await logoutUser(email);
            localStorage.removeItem('authToken');
            localStorage.removeItem('loggedInUserEmail');
            localStorage.removeItem('is_admin');
            window.location.href = '/login';
        } catch (error) {
            alert('Logout failed. Please try again.');
        }
    };

    const handleSelfEvaluation = async () => {
        setEvaluationPopupVisible(true);
        try {
            const response = await fetch(
                `${API_BASE_URL}/call_self_evaluation/`,
                { 
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        user_id: email || 'test'
                    })
                }
            );

            if (response.status === 409) {
                // Another self-evaluation or rescoring is running; the server says which.
                const refused = await response.json();
                setEvaluationPopupVisible(false);
                alert(refused.message);
                return;
            }
            if (!response.ok) {
                throw new Error('Self Evaluation API call failed.');
            }

            const data = await response.json();
            
        } catch (error) {
            console.error('Error during Self Evaluation:', error);
        }
        
    };



    useEffect(() => {
        avg_score_data();
    }, [avg_score_data]);
	const openSelfEvaluationDropDown = (e) => {
	
		// Toggle the current dropdown
		const targetedElement = e.currentTarget.closest('.targeted-element'); // Adjust this selector as needed
		const nextElement = targetedElement?.nextElementSibling; // Get the next sibling dropdown
	
		if (nextElement) {
		  if (!nextElement.classList.contains('active')) {
			// Close all currently open dropdowns
			const allDropdowns = document.querySelectorAll('.pof2frms-dropdown.active');
			allDropdowns.forEach(dropdown => dropdown.classList.remove('active'));
			nextElement.classList.add('active'); // Open the current dropdown
		  } else {
			nextElement.classList.remove('active'); // Close if it's already open
		  }
		}
	
		e.stopPropagation(); // Prevent event bubbling to document click handler
	  };
	
	  useEffect(() => {
		const handleOutsideClick = (e) => {
		  if (!e.target.closest('.pof2frms-dropdown') && !e.target.closest('.targeted-element')) {
			const allDropdowns = document.querySelectorAll('.pof2frms-dropdown.active');
			allDropdowns.forEach(dropdown => dropdown.classList.remove('active'));
		  }
		};
		document.addEventListener('click', handleOutsideClick);
		return () => {
		  document.removeEventListener('click', handleOutsideClick);
		};
	  }, []);
    return (
        <header>
            {/* {test && (<div>Pass</div>)} */}
            
            <div className="po2frm-header-inner">
                <nav>
                    <ul className="po2frms-menu">
                        {isAdmin && (
                            <>
                                <li>
                                    <Link to={"/dashboard"} className={isActive("/dashboard") ? "active" : ""}>
                                        Dashboard
                                    </Link>
                                </li>
                                <li>
                                    <Link to={"/users"} className={isActive("/users") ? "active" : ""}>
                                        Users
                                    </Link>
                                </li>
                                <li>
                                    <Link to={"/builder-rules"} className={isActive("/builder-rules") ? "active" : ""}>
                                        Builder Rules
                                    </Link>
                                </li>
                                <li>
                                    <Link to={"/orders-lisiting"} className={isActive("/orders-lisiting") ? "active" : ""}>
                                        Order Listing
                                    </Link>
                                </li>
                                <li>
                                    <Link to={"/settings"} className={isActive("/settings") ? "active" : ""}>
                                        Settings
                                    </Link>
                                </li>
                            </>
                        )}
                    </ul>
                </nav>
                <div className="po2frms-actions">
                    <div className="pof2frms-dd">
                        <span
                            className="targeted-element"
                            
                        >
                            <span>Self Evaluation <span 
                                className={`pof2frms-tags score-tooltip ${avgScore !== null && avgScore < 90 ? 'red-bg' : ''}`}
                                data-score-tooltip="Current average score from self-evaluation process"
                            >
                                {avgScore !== null ? avgScore : '0'}</span>
                                {Object.keys(runningRuleSets).length > 0 && (
                                    <span 
                                        className="pof2frms-tags red-bg score-tooltip" 
                                        style={{marginLeft: '5px'}}
                                        data-score-tooltip="Number of rule sets compiling or scoring right now"
                                    >
                                        {Object.keys(runningRuleSets).length}
                                    </span>
                                )}
                            </span>
								{isAdmin &&(
									<span onClick={(e) => openSelfEvaluationDropDown(e)}></span>
								)}
                        </span>
                        
						{isAdmin && (
                        <ul className="pof2frms-dropdown">
                            <li><Link data-numbers="93" to="#" onClick={handleSelfEvaluation}>Start Self Evaluation</Link></li>
                            <li><Link data-numbers="999" to={isAdmin ? "/test-cases/" : '#'}>Test Cases</Link></li>
                            <li><Link data-numbers="111" to={isAdmin ? "/dashboard/" : '#'}>Self evaluation history</Link></li>
                        </ul>
                        )}
                    </div>
                    <div className="pof2frms-dd">
                        <span className="targeted-element">
                            <span className="user-avatar">
                                <img src={profileIcon} alt={email} />
                            </span>
                            {email}
							<span onClick={(e) => openSelfEvaluationDropDown(e)}></span>
                        </span>
                        <ul className="pof2frms-dropdown">
                            <li><a href="#" onClick={handleLogout}>Logout</a></li>
                        </ul>
                    </div>
                </div>
            {isEvaluationPopupVisible && (
            <div className="pof2frms-popup-wrapper pof2frms-popup-center" id="score-file">
              <div className="popup-overlay" onClick={closeEvaluationPopup}></div>
              <div className="pof2frms-popup-container">
                <h3>Performing Self Evaluation</h3>
                <p>
                  This will take about 10-15 minutes.<br />
                  We will notify you when scoring is complete
                </p>
                <div className="pof2frms-popup-action">
                  <button type="button" className="pof2frms-activated" onClick={closeEvaluationPopup}>
                    Okay
                  </button>
                </div>
              </div>
            </div>
            )}
            <div className="notify-wrapper">
                {isScoreVisible && notifications.map(notification => (
                    <ScoringNotify
                        key={notification.id}
                        id={notification.id}
                        onClose={handleNotificationClose}
                        sendDataToParent={handleMessageFromChild}
                        selectedBuilder={selectedBuilder.builder_name}
                        setScoreVisible={setScoreVisible}
                        message={notification.text}
                        process={process}
                    />
                ))}
            </div>

            </div>
        </header>
    );
}

export default Header;
